import { useEffect, useState } from 'react'

import axiosPrivate from '../hooks/useAxiosPrivate'
import useAuth from '../hooks/useAuth'
import moment from 'moment'

const ActiveReferrals = () => {
  const { createInfo } = useAuth()

  const axios = axiosPrivate();
  const [enquiries, setEnquiries] = useState(null)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchEnquiries()
  }, [])

  const fetchEnquiries = async () => {
    setLoading(true)
    try {
      const response = await axios.get('/enquiries/all')

      if (response.status !== 200) {
        console.error('Error fetching resources:', response)
        createInfo('error', 'Error fetching resources')
      }

      setEnquiries(response.data.result || [])
    } catch (error) {
      console.error('Error fetching resources:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="mt-2 mb-2">
      {loading ? (
        <p>Loading your enquiries...</p>
      ) : (
        <>
          {!enquiries || enquiries.length === 0 ? (
            <p>No Upcoming Appointments</p>
          ) : (
            <>
              <h2 className="text-xl font-medium pb-4">Your Enquiries</h2>
              <div className="space-y-6 max-w-3xl">
                {enquiries.map((enquiry, index) => (
                  <div key={index} >
                    <div className="mb-1">
                      <h3 className="font-medium">
                        {enquiry.title.replace('Service Request - ', '')}
                      </h3>
                    </div>
                    <p className="text-sm text-gray-600">
                      {moment(enquiry.created_at).format('dddd Do MMMM YYYY, h:mm A')}
                    </p>
                    <hr className="mt-4 border-[#e8e0ed]" />
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default ActiveReferrals
